var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1.2,
      spaceBetween: 20,
      loop: true,
      speed: 8000,
      autoplay: {
        delay: 0,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      },
      on: {
        click: function (event) {
          UIkit.slider("#sliderModal",{
            index:event.clickedSlide.getAttribute("data-index")
          })
          setTimeout(function () {
            document.querySelector('.slider-box').style.opacity = 1
          })
        }
      }
      //  pagination: {
      //    el: ".swiper-pagination",
      //    clickable: true,
      //  },
    });


    // function playPause(a,b,e) {
    //   var videoDom = a.parentNode.parentNode.children[0].children[0]
    //   console.log(videoDom,'videoDom')
    //   console.log(videoDom.paused,'videoDom.paused')
    //   if (videoDom.paused) {
    //     videoDom.play(); 
    //   }else {
    //     videoDom.pause(); 
    //   }
    // }

    // function playPause(event, videoId) {
    //   console.log('event', event.target);
    //   var videoDom = document.getElementById(videoId)
    //   if (videoDom) {
    //     if (videoDom.paused) {
    //       videoDom.play();
    //       event.target.setAttribute('class', 'pause')
    //     } else {
    //       videoDom.pause();
    //       event.target.setAttribute('class', 'play')
    //     }
    //   }
    // }

    class bVideo extends HTMLElement {
      constructor() {
        super()
        this.playState = 0;
        const mediaQuery = window.matchMedia('(min-width: 959px)');
        const self = this;
        
        // console.log('w1 2 matchMedia!', mediaQuery.matches)
        const handleTabletChange = function (e) {
          // console.log('w1 1 matchMedia!', e.matches)
          if (e.matches) {
            self.video = self.querySelector('video');
          } else {
            self.video = [...self.querySelectorAll('video')].pop();
          }
        }
        mediaQuery.addListener(handleTabletChange);
        handleTabletChange(mediaQuery);
        this.btn = this.querySelector('button');
        this.init();
      }

      init() {
        this.listenEvent();
        this.clickHandle();
      }

      listenEvent() {
        this.video.addEventListener('play', () => {
          // console.log("播放开始", this.video.getAttribute('src'));
          // this.changeState(0);
          this.changeState(0);
        }, false);

        this.video.addEventListener('pause', () => {
          // console.log("播放暂停", this.video.getAttribute('src'));
          // this.changeState(2);
          this.changeState(1);
        }, false);

        this.video.addEventListener('ended', () => {
          // console.log("播放结束", this.video.getAttribute('src'));
          this.changeState(2);
        }, false);
      }

      clickHandle() {
        this.btn.addEventListener('click', () => {
          this.video.paused ? this.video.play() : this.video.pause();
        })
      }

      /**
       * state Number
       * 0  
       * 1  
       * *
      */
      changeState(state) {
        if (state === 0) {
          this.btn.querySelector('i').setAttribute('class', 'pause')
        } else if (state === 1) {
          this.btn.querySelector('i').setAttribute('class', 'play')
        } else {
          this.btn.querySelector('i').setAttribute('class', 'replay')
        }
      }
    }


    customElements.define('b-video', bVideo);